import { render, staticRenderFns } from "./CadastroDivisao.vue?vue&type=template&id=e6ac3cae&lang=html&"
import script from "./CadastroDivisao.vue?vue&type=script&lang=js&"
export * from "./CadastroDivisao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/divisao/CadastroDivisao.vue
// module id = 1310
// module chunks = 28